import { RouteProps } from 'react-router';

import { urlLang } from '../../helpers/langHelper';
import { Register } from '../../containers/Register/Register';

export const BASE_ROUTE = '/#';

export const getBaseName = (): string => `/${urlLang()}${BASE_ROUTE}`;

export const PATH_OF_ROUTES = {
    REGISTER: '/register',
};

export const routes: RouteProps[] = [
    {
        path: PATH_OF_ROUTES.REGISTER,
        component: Register,
    },
];
